import { render, staticRenderFns } from "./CombineCaseDetailInput.vue?vue&type=template&id=5f885c0b&scoped=true&"
import script from "./CombineCaseDetailInput.vue?vue&type=script&lang=js&"
export * from "./CombineCaseDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./CombineCaseDetailInput.vue?vue&type=style&index=0&id=5f885c0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f885c0b",
  null
  
)

export default component.exports